export default "__VITE_ASSET__BbKCXWGW__"